var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column align-center justify-center text-center py-6",
                },
                [
                  _c("h3", { staticClass: "mb-8" }, [
                    _vm._v("Actualizar Estado De Transacciones"),
                  ]),
                ]
              ),
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "450px", persistent: "" },
                      model: {
                        value: _vm.showModalAlert,
                        callback: function ($$v) {
                          _vm.showModalAlert = $$v
                        },
                        expression: "showModalAlert",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "headline" },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showModalAlert = false
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-close")])],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card-text",
                            { staticClass: "tx-center" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "icon-warning",
                                  attrs: { color: "gray" },
                                },
                                [_vm._v("mdi mdi-alert-circle-outline")]
                              ),
                              _c(
                                "div",
                                { staticClass: "mt-3" },
                                [
                                  _c("h6", [
                                    _vm._v(
                                      "¿Estás seguro de modificar los registros?"
                                    ),
                                  ]),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Razón del cambio",
                                      outlined: "",
                                      dense: "",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.reasonStatus,
                                      callback: function ($$v) {
                                        _vm.reasonStatus = $$v
                                      },
                                      expression: "reasonStatus",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    justify: "center",
                                    "no-gutters": "",
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-sm-right",
                                      attrs: { cols: "12", sm: "6" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "can",
                                              rawName: "v-can",
                                              value:
                                                "Actualizar Estado Transacciones",
                                              expression:
                                                "'Actualizar Estado Transacciones'",
                                            },
                                          ],
                                          staticClass: "ma-2",
                                          staticStyle: {
                                            "background-color":
                                              "rgb(204 33 40)",
                                            color: "white !important",
                                          },
                                          attrs: {
                                            disabled: !_vm.isReasonValid,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.updateInvoices.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi mdi-thumb-up")]
                                          ),
                                          _vm._v(" Si "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-sm-left",
                                      attrs: { cols: "12", sm: "6" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-2",
                                          attrs: { color: "gray" },
                                          on: {
                                            click: function ($event) {
                                              _vm.showModalAlert = false
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [
                                              _vm._v(
                                                "mdi mdi-thumb-down-outline"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" No "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.formValid,
                    callback: function ($$v) {
                      _vm.formValid = $$v
                    },
                    expression: "formValid",
                  },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto", sm: "4" } },
                        [
                          _c("v-select", {
                            ref: "client",
                            attrs: {
                              items: _vm.filteredClients,
                              "item-text": "text",
                              "item-value": "company",
                              label: "Selecciona Una Compañía",
                              "prepend-inner-icon": "mdi mdi-select-search",
                              required: "",
                              dense: "",
                              outlined: "",
                            },
                            on: { change: _vm.fetchToken },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend-item",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item",
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    placeholder: "Buscar",
                                                    "prepend-inner-icon":
                                                      "mdi-magnify",
                                                    "hide-details": "",
                                                    dense: "",
                                                  },
                                                  model: {
                                                    value: _vm.search,
                                                    callback: function ($$v) {
                                                      _vm.search = $$v
                                                    },
                                                    expression: "search",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.dataFilter.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataFilter, "company", $$v)
                              },
                              expression: "dataFilter.company",
                            },
                          }),
                          _vm.loadingToken
                            ? _c("div", [
                                _c("em", [_vm._v("Obteniendo token...")]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "auto", sm: "4" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              label: "Consecutivos (Separados Por Coma)",
                              "prepend-inner-icon": "mdi-file-document",
                              dense: "",
                              outlined: "",
                              required: "",
                              placeholder: "Ej: FE123,FE124,FE130",
                              rows: "1",
                              "auto-grow": "",
                              rules: _vm.consecutiveRules,
                              "error-messages": _vm.errorMessages,
                            },
                            model: {
                              value: _vm.dataFilter.consecutive,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataFilter, "consecutive", $$v)
                              },
                              expression: "dataFilter.consecutive",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { justify: "center", "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-sm-right",
                      attrs: { cols: "12", sm: "6" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "can",
                              rawName: "v-can",
                              value: "Actualizar Estado Transacciones",
                              expression: "'Actualizar Estado Transacciones'",
                            },
                          ],
                          staticClass: "ma-2",
                          staticStyle: {
                            "background-color": "rgb(204 33 40)",
                            color: "white !important",
                          },
                          attrs: {
                            disabled: _vm.isLoadingUpdate,
                            loading: _vm.isLoadingUpdate,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.showAlertUpdateInvoices.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi mdi-invoice-text-remove-outline"),
                          ]),
                          _vm._v(" Actualizar Registros "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          attrs: {
                            disabled: _vm.loading && _vm.files.length === 0,
                            color: "gray",
                          },
                          on: { click: _vm.clearFields },
                        },
                        [_vm._v(" Limpiar ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "my-4", attrs: { justify: "center" } },
                [
                  _vm.isLoadingUpdate
                    ? _c("v-progress-linear", {
                        staticClass: "my-4",
                        attrs: { color: "danger", indeterminate: "" },
                      })
                    : _vm._e(),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _vm.showAlert
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "my-4",
                              attrs: {
                                type: _vm.alertType,
                                dense: "",
                                outlined: "",
                                border: "left",
                                "colored-border": "",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }